import React from 'react';
import Vm from 'views/Vm';

const vmPage = () => {
  return <Vm/>;
};

export default vmPage;